export class Maybe {
  constructor(private _value) {}

  public of(value) {
    return new Maybe(value);
  }

  public map(mapper) {
    if (this.isNothing()) {
      return new Maybe(null);
    }

    return this.of(mapper(this._value));
  }

  public chain(mapper) {
    return this.map(mapper).join();
  }

  public orElse(defaultValue) {
    if (this.isNothing()) {
      return this.of(defaultValue);
    }

    return this;
  }

  public join() {
    return this._value;
  }

  private isNothing() {
    return this._value == null;
  }
}
